import { URLSearchParams, QueryEncoder } from '@angular/http';
import { URLParams } from '../../../../core/url-params.model';

export class ContractsAccrualsHttpUtil {

  public static prepareParamsAccrualsContracts(params): URLSearchParams {
    let urlParams = new URLParams();

    if (params.securityToken) {
      urlParams.append('securityToken', params.securityToken);
    }
    if (params.futureAccruals || params.futureAccruals === 0) {
      urlParams.append('futureAccruals', params.futureAccruals);
    }
    if (params.payedAccruals || params.payedAccruals === 0) {
      urlParams.append('payedAccruals', params.payedAccruals);
    }
    if (params.accrualsType) {
      urlParams.append('accrualsType', params.accrualsType);
    }
    return urlParams;
  }

  public static prepareParamsAccrualsInvoice(params): URLSearchParams {
    let urlParams = new URLParams();

    if (params.securityToken) {
      urlParams.append('securityToken', params.securityToken);
    }
    if (params.accrualsIds) {
      urlParams.append('accrualsIds', params.accrualsIds);
    }
    return urlParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/accruals/contracts.accruals.util.ts